import { HttpErrorResponse } from '@angular/common/http';

/**
 * User-visible text for API failures. Backend 400 responses often use an array of strings for
 * `message` (Yii + restproject `Response` beforeSend).
 */
export function getApiErrorMessage(err: unknown, fallback = 'Request failed'): string {
  if (err instanceof HttpErrorResponse) {
    const body: unknown = err.error;
    if (typeof body === 'string' && body.trim().length) {
      return body;
    }
    if (body && typeof body === 'object' && !Array.isArray(body)) {
      const b = body as Record<string, unknown>;
      const m = b['message'];
      if (typeof m === 'string' && m) {
        return m;
      }
      if (Array.isArray(m) && m.length) {
        const text = m
          .map(x => (x == null ? '' : String(x)))
          .filter(s => s.trim().length)
          .join('\n');
        if (text) {
          return text;
        }
      }
    }
    if (err.message) {
      return err.message;
    }
  }
  if (err && typeof err === 'object' && 'message' in (err as object)) {
    const m = (err as { message?: unknown }).message;
    if (typeof m === 'string' && m) {
      return m;
    }
    if (Array.isArray(m) && m.length) {
      return m.map(x => String(x)).filter(s => s.trim().length).join('\n');
    }
  }
  return fallback;
}
